import { render, staticRenderFns } from "./purchaseCashbackList.vue?vue&type=template&id=2b9440d4&scoped=true&"
import script from "./purchaseCashbackList.vue?vue&type=script&lang=js&"
export * from "./purchaseCashbackList.vue?vue&type=script&lang=js&"
import style0 from "./purchaseCashbackList.vue?vue&type=style&index=0&id=2b9440d4&prod&lang=scss&scoped=true&"
import style1 from "./purchaseCashbackList.vue?vue&type=style&index=1&id=2b9440d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9440d4",
  null
  
)

export default component.exports